import { DeliveryError } from '../delivering/DeliveryError';

export interface IssuePermitApplicationResponse {
  driverDelivery?: DriverDeliveryResponse;
}

export type DriverDeliveryResponse =
  | { status: DriverDeliveryStatus.SUCCEEDED }
  | { status: DriverDeliveryStatus.FAILED; error: DeliveryError };

export enum DriverDeliveryStatus {
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}
